import React from 'react'

// import { pathPrefix } from '@root/gatsby-config.js'

// Hook
const useMenuLink = () => {
    return [
        {
            label: 'About',
            to: '/',
            target: '#about'
        }
    ]
}

const useFooterLink = () => {
    return [
        {
            label: '',
            to: ''
        }
   ]
}

const useURL = () => {
    return {
        home: `/`,
        googleplay: `https://play.google.com/store/apps/details?id=com.adobe.psmobile`,
        product: `https://www.fmworld.net/product/phone/f-51a/`,
        company: `https://www.fujitsu.com/jp/group/fcnt/about/`,
        privacy: `https://www.fujitsu.com/jp/group/fcnt/privacy/`,
        facebook: `https://google.com`,
        twitter: `https://google.com`,
        siteurl: `https://www.fmworld.net/product/phone/f-51a/arrows-adobe`,
    }
}

export { useMenuLink, useFooterLink, useURL }